import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Destinations from './pages/Destinations'
import TripDetails from './pages/TripDetails'
import About from './pages/About'
import Contact from './pages/Contact'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import { RealtimeProvider } from './contexts/RealtimeContext'

function App() {
  return (
    <RealtimeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Admin Routes - No Navbar/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            
            {/* Public Routes - With Navbar/Footer */}
            <Route path="/" element={
              <>
                <Navbar />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/destinations" element={
              <>
                <Navbar />
                <Destinations />
                <Footer />
              </>
            } />
            <Route path="/trip/:id" element={
              <>
                <Navbar />
                <TripDetails />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navbar />
                <About />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Navbar />
                <Contact />
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </RealtimeProvider>
  )
}

export default App
